import React from 'react';
import StudentDashboardLayout from '../../../layouts/gcstudent/studentdashboardLayout/StudentDashboardLayout';
import SavedPDFSPAGE from '../../../subsreens/gcstudent/savedPdfspage/SavedPDFSPAGE';


const SavedPDFS = () => {
    return(
        <StudentDashboardLayout>
            <SavedPDFSPAGE/>
        </StudentDashboardLayout>
    )
}

export default SavedPDFS;